import React, {useRef, useState} from "react";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import {DateRangePicker} from "react-dates";
import { Row} from "../Layout";
import NTMButton from "../Buttons/NTMButton";


export default function IntervalBarTrapinst ({
	showDaily = true, showWeekly = true, showMonthly = true, showInterval = true,
	interval, setInterval: setIntvl, startDate, setStartDate, endDate, setEndDate, maxDate, minDate,
}) {

	let [focusedInput, setFocusedInput] = useState();
	let buttonRef = useRef();

	return (
			<Row>
				{showDaily && <NTMButton
					primary={interval === "daily"}
					unselected={interval !== "daily" ? 'true' : undefined}
					onClick={() => setIntvl("daily")}
				>Oggi</NTMButton>}
				{showWeekly && <NTMButton
					primary={interval === "weekly"}
					unselected={interval !== "weekly" ? 'true' : undefined}
					onClick={() => setIntvl("weekly")}
				>Ultimi 7 gg</NTMButton>}
				{showMonthly && <NTMButton
					primary={interval === "monthly"}
					unselected={interval !== "monthly" ? 'true' : undefined}
					onClick={() => setIntvl("monthly")}
				>Ultimi 30 gg</NTMButton>}
				{showInterval && <div data-tip data-for='global' data-event='click' ref={buttonRef}>
					<NTMButton
						primary={interval === "custom"}
						unselected={interval !== "custom" ? 'true' : undefined}
					>
						{
							startDate ?
								`${moment(startDate).format("DD/MM/YYYY")}
											-
											${moment(endDate).format("DD/MM/YYYY")}`
							: <>Scegli Periodo&nbsp;<i className="fa fa-caret-down" aria-hidden="true" /></>
						}
					</NTMButton>
				</div>}
				<ReactTooltip
					id='global'
					aria-haspopup='true'
					effect='solid'
					place={"bottom"}
					clickable
					getContent={() => <DateRangePicker
						startDate={startDate} // momentPropTypes.momentObj or null,
						startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
						endDate={endDate} // momentPropTypes.momentObj or null,
						endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
						onDatesChange={({startDate, endDate}) => {
							if (startDate !== null && endDate !== null) {
								buttonRef.current.click();
							}
							setIntvl("custom")
							setStartDate(startDate)
							setEndDate(endDate)
						}} // PropTypes.func.isRequired,
						focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
						onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
						withPortal={true}

						startDatePlaceholderText={"Inizio"}
						endDatePlaceholderText={"Fine"}
						displayFormat={"DD/MM/YYYY"}
						isOutsideRange={o => !o.isBetween(minDate, maxDate || moment(), 'day', '[]')}
						small={true}
					/>}
				/>
			</Row>
	);
}
